// import React from 'react';
// import {View, Linking, StyleSheet, TouchableOpacity} from 'react-native';
// import {
//   Text,
//   Header,
//   ImageIcon,
//   InputLabel,
//   Loading,
//   Error,
//   ListContainer,
// } from 'component';

// import {colors, sizes, strings} from 'asset/constant';
// import {css} from 'style';
// import {useContactUs} from 'client/api';
// import {mq} from 'utils';

// const RowInfo = (props: {title: string; value: string}) => {
//   return (
//     <View
//       style={{
//         ...css.rRow,
//         marginBottom: mq(10),
//         marginLeft: sizes.space,
//       }}>
//       <View style={{width: mq(120)}}>
//         <Text color={colors.text.gray} style={{marginLeft: sizes.space}}>
//           {props.title}:
//         </Text>
//       </View>
//       <View style={css.container}>
//         <Text weight="medium" style={{lineHeight: mq(24)}}>
//           {props?.value}
//         </Text>
//       </View>
//     </View>
//   );
// };

// export default function ContactUs() {
//   const {data, isLoading, isError, refetch} = useContactUs();
//   const contactUsInfos = data?.data?.contactUsInfo;
//   const contactAddresses = data?.data?.contactAddresses;
//   const socialNetworks = data?.data?.socialNetworks;

//   const _onGoToSocial = (url: string) => Linking.openURL(url);

//   const _renderContent = () => {
//     if (isLoading) {
//       return <Loading />;
//     }

//     if (isError) {
//       return <Error reset={refetch} />;
//     }

//     return (
//       <>
//         {contactUsInfos?.length > 0 && (
//           <View style={{marginBottom: sizes.space * 2}}>
//             <InputLabel label={strings.call_ways} />
//             {contactUsInfos?.map(
//               (info: {name: string; value: string}, key: number) => (
//                 <RowInfo
//                   key={String(key)}
//                   title={info.name}
//                   value={info.value}
//                 />
//               ),
//             )}
//           </View>
//         )}

//         {contactAddresses?.length > 0 && (
//           <View style={{marginBottom: sizes.space * 2}}>
//             <InputLabel label={strings.address} />
//             {contactAddresses?.map(
//               (info: {name: string; value: string}, key: number) => (
//                 <RowInfo
//                   key={String(key)}
//                   title={info.name}
//                   value={info.value}
//                 />
//               ),
//             )}
//           </View>
//         )}

//         {socialNetworks?.length > 0 && (
//           <>
//             <View
//               style={{
//                 width: '100%',
//                 height: 1,
//                 backgroundColor: colors.white,
//                 marginBottom: mq(30),
//               }}
//             />
//             {/* <View style={styles.socialsSectionTopBorder}>
//               <View
//                 style={{
//                   width: '100%',
//                   height: mq(1),
//                   backgroundColor: colors.white,
//                   borderRadius: 10,
//                 }}
//               />
//             </View>*/}
//             <View style={styles.socialsContainer}>
//               {socialNetworks.map(
//                 (
//                   social: {image: string; value: string; type: string},
//                   key: number,
//                 ) => (
//                   <TouchableOpacity
//                     activeOpacity={sizes.tapOpacity}
//                     onPress={() => social.value && _onGoToSocial(social.value)}
//                     key={String(key)}
//                     style={styles.socialBox}>
//                     <ImageIcon icon={{uri: social?.image}} />
//                   </TouchableOpacity>
//                 ),
//               )}
//             </View>
//           </>
//         )}
//       </>
//     );
//   };

//   return (
//     <>
//       <Header title={strings.contact_us} />
//       <ListContainer>{_renderContent()}</ListContainer>
//     </>
//   );
// }

// const styles = StyleSheet.create({
//   socialsContainer: {
//     ...css.rRow,
//     ...css.wrap,
//     ...css.centralElements,
//   },

//   socialBox: {
//     height: 0,
//     width: '20%',
//     aspectRatio: 1,
//     borderWidth: 1,
//     borderColor: colors.white,
//     borderRadius: sizes.radius.lg,
//     backgroundColor: colors.lightButtons,
//     elevation: 1,
//     ...css.centralElements,
//     marginTop: sizes.space,
//     marginHorizontal: sizes.space / 2,
//   },

//   socialsSectionTopBorder: {
//     height: 3,
//     width: '100%',
//     elevation: 1,
//     borderRadius: 10,
//     marginBottom: mq(15),
//     backgroundColor: colors.lightButtons,
//     justifyContent: 'flex-end',
//   },
// });

import React from "react";
import { Header, ListContainer, Text } from "component";
import { sizes, strings } from "asset/constant";
import { Linking, TouchableOpacity, View } from "react-native";

export default function ContactUs() {
  return (
    <>
      <Header title={strings.contact_us} />

      <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
        <Text weight="bold">شماره تماس</Text>
        <TouchableOpacity
          style={{ marginTop: 15 }}
          activeOpacity={sizes.tapOpacity}
          onPress={() => {
            Linking.openURL("tel:09138717870");
          }}
        >
          <Text weight="black">09138717870</Text>
        </TouchableOpacity>
      </View>
    </>
  );
}
